import { IValidationRule } from "@/types"

const assetDisposalValidationRules: { [s: string]: IValidationRule } = {
    reason: {
        required: true
    },
    date: {
        required: true
    },
    description: {
        required: true
    },
}

export default assetDisposalValidationRules
